import { IS_PROD_ENV } from 'environment/environment';
import showToast from 'shared/errorHandling/ErrorToast/ErrorToast';
import { ErrorStatus, ErrorType } from 'types/ApiError/ErrorEnums';
import FmPrpApiError from 'types/ApiError/FmPrpApiError';
import GenericErrorMessage from 'types/generalEnums/GenericErrorMessage';

function capitalizeFirstLetter(message: string): string {
  return message.charAt(0).toUpperCase() + message.slice(1);
}

function isStringJSONInFormat(str: string): boolean {
  const regex = /^\{"[^"]*":\[[^\]]*\]\}$/;
  return regex.test(str);
}

function addSpaceBeforeUpperCaseWords(jsonString: string): string {
  const obj: { [key: string]: never } = JSON.parse(jsonString);

  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const modifiedKey = key.replace(/[A-Z]/g, (match) => ` ${match}`);
      if (modifiedKey !== key) {
        obj[modifiedKey] = obj[key];
        delete obj[key];
      }
    }
  }
  return JSON.stringify(obj);
}

function formatErrorBody(errorBody: string): string {
  const fixedErrorBody = isStringJSONInFormat(errorBody)
    ? addSpaceBeforeUpperCaseWords(errorBody)
    : errorBody;
  const errorBodyReplace = /[[{}|&;$%@"<>()+]/g;
  const result =
    `${fixedErrorBody
      .replaceAll(']', '')
      .replaceAll(',', ', ')
      .replace(errorBodyReplace, '')
      .replaceAll(':', ' ')}` ?? GenericErrorMessage.ContactAdministrator;
  return capitalizeFirstLetter(result);
}

export function notifyUser(
  errorTitle: string = GenericErrorMessage.SomethingWentWrong,
  errorBody: string = GenericErrorMessage.ContactAdministrator
): void {
  showToast(
    'error',
    errorTitle ?? GenericErrorMessage.SomethingWentWrong,
    formatErrorBody(errorBody)
  );
}
export function notifyUserWith(message: string) {
  notifyUser(
    GenericErrorMessage.SomethingWentWrong,
    message ?? GenericErrorMessage.ContactAdministrator
  );
}

export function logError(message: string): void {
  if (!IS_PROD_ENV) {
    /* eslint-disable */
    console.error(message);
  }
}

export class ApiError extends Error {
  header: string;
  type: ErrorType;
  status: ErrorStatus;
  errorsMap: Record<string, string>;

  constructor(apiError: FmPrpApiError) {
    super(apiError.message);
    Object.setPrototypeOf(this, ApiError.prototype);
    this.header = apiError.header;
    this.type = apiError.type;
    this.status = apiError.status;
    this.errorsMap = apiError.errorsMap;
  }
}
